<modal #modal [css-class]="">
    <ng-container *ngIf="!expired">
        <div class="modal-header">
            <h5 class="modal-title">
                Du logges snart ud
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
                
            </button>
        </div>

        <div class="modal-body">
            <p>Vi kan konstatere, at der ikke har været aktivitet på denne side i lang tid. Grundet dette, bliver du af sikkerhedsmæssige årsager logget ud af Min side, hvis ikke du agerer snarest.</p>

            <button type="button" class="cta cta--primary" aria-label="Close" (click)="renew()">
                Fortsæt min session
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="expired">
        <div class="modal-header">
            <h5 class="modal-title">
                Du er blevet logget ud
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="browserRefresh()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>Vi kan konstatere, at der ikke har været aktivitet på denne side i lang tid. Grundet dette, er du af sikkerhedsmæssige årsager blevet logget ud af Min side.</p>

            <button type="button" class="cta cta--primary" aria-label="Close" (click)="gotoLogin()">
                Login igen
            </button>

            <p class="pt-3">Oplever du problemer, så kontakt Kundeservice via vores chat, <a style="color: #6e1eff"
                    href="mailto:kundeservice@klasselotteriet.dk">e-mail</a> eller telefon: 3342 0900, mandag-fredag
                9.00-18.00.</p>
        </div>
    </ng-container>
</modal>
